import { PaymentType } from '../../../types/common';
import {
  ADD_HISTORY,
  DATA_FETCHING,
  RESET_HISTORY,
  SET_DATA_TYPE,
  SET_FETCHING_ERROR,
  UPDATE_HISTORY
} from '../constants';
import { Action, HistoryDataPayload } from '../types';

export const setIsErrorAction = (state = true): Action<HistoryDataPayload> => ({
  type: SET_FETCHING_ERROR,
  payload: {
    isFetchingError: state
  }
});

export const setIsFetchingAction = (
  state = true
): Action<HistoryDataPayload> => ({
  type: DATA_FETCHING,
  payload: {
    isFetching: state
  }
});

export const setDataTypeAction = (
  state: PaymentType
): Action<HistoryDataPayload> => ({
  type: SET_DATA_TYPE,
  payload: {
    dataType: state
  }
});

export const setAddHistoryAction = ({
  data,
  totalPages,
  page
}: HistoryDataPayload): Action<HistoryDataPayload> => ({
  type: ADD_HISTORY,
  payload: {
    data,
    page,
    totalPages,
    isFetching: false
  }
});

export const setUpdateHistoryAction = ({
  data,
  totalPages,
  page
}: HistoryDataPayload): Action<HistoryDataPayload> => ({
  type: UPDATE_HISTORY,
  payload: {
    data,
    page,
    totalPages,
    isFetching: false
  }
});

export const setResetHistoryAction = (): Action<HistoryDataPayload> => ({
  type: RESET_HISTORY
});
